import {
  wixCliLoginEnd,
  wixCliLoginStart,
} from '@wix/bi-logger-dev-tools-data/v2';
import { addUserFields } from '@wix/cli-telemetry';
import type { BiLogger } from '@wix/cli-telemetry';
import type { UserInfo } from './schemas.js';

export function reportLoginStart(biLogger: BiLogger): void {
  void biLogger.report(wixCliLoginStart({}));
}

export function reportLoginSuccess(
  biLogger: BiLogger,
  userInfo: UserInfo
): void {
  addUserFields(biLogger, userInfo.userId);
  void biLogger.report(wixCliLoginEnd({ isSuccess: true }));
}

export function reportLoginFailure(biLogger: BiLogger, error: unknown): void {
  void biLogger.report(
    wixCliLoginEnd({
      isSuccess: false,
      ...(error instanceof Error
        ? {
            errorType: error.name,
          }
        : {
            errorType: 'unknown',
            errorMessage: JSON.stringify(error),
          }),
    })
  );
}
